import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "z-10 w-full text-center font-semibold text-sm leading-[21px] md:font-medium md:text-base md:leading-100p"
}
const _hoisted_2 = { class: "min-h-[38px] min-w-[38px] md:min-h-[46px] md:min-w-[46px] flex items-center justify-center rounded-full bg-white transition-transform z-10 ml-auto" }


import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GradientButton',
  props: {
  bgColor: {
    type: String,
  },
  hoverBgColor: {
    type: String,
  },
  text: {
    type: String,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["group relative flex items-center justify-between px-1 md:px-2 rounded-full text-white font-sf text-[18px] leading-[24px] font-medium overflow-hidden transition-colors", {
      'opacity-80 pointer-events-none': __props.isLoading || __props.isDisabled,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    (__props.isLoading)
      ? (_openBlock(), _createBlock(LoaderIcon, { key: 0 }))
      : _createCommentVNode("", true),
    (!__props.isLoading && __props.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.text), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(ArrowIcon, { class: "text-brown group-hover:text-active transition-transform duration-300 ease-in-out group-hover:rotate-45" })
      ])
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["absolute inset-0 transition-opacity duration-300 ease-in-out group-hover:opacity-0", props.bgColor])
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(["absolute inset-0 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100", props.hoverBgColor])
    }, null, 2)
  ], 2))
}
}

})